export default __webpack_public_path__ + "static/media/ArrowLeft.838e5c0a.svg";